/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_DescriptionInputs */

const en_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure CCSL export settings`)
};

const fr_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer les parametres d'exportation CCSL`)
};

const de_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL-Exporteinstellungen konfigurieren`)
};

const it_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurare le impostazioni di esportazione CCSL`)
};

const ru_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка параметров экспорта CCSL`)
};

const es_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar los ajustes de exportación CCSL`)
};

const zh_cn2_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置 CCSL 导出设置`)
};

const ja_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSLエクスポート設定を構成する`)
};

const hi_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL निर्यात सेटिंग्स को कॉन्फ़िगर करें`)
};

const pt_pt2_ccsl_export_description = /** @type {(inputs: Ccsl_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar as definições de exportação do CCSL`)
};

/**
* | output |
* | --- |
* | "Configure CCSL export settings" |
*
* @param {Ccsl_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_description = /** @type {((inputs?: Ccsl_Export_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_description(inputs)
	if (locale === "de") return de_ccsl_export_description(inputs)
	if (locale === "it") return it_ccsl_export_description(inputs)
	if (locale === "ru") return ru_ccsl_export_description(inputs)
	if (locale === "es") return es_ccsl_export_description(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_description(inputs)
	if (locale === "ja") return ja_ccsl_export_description(inputs)
	if (locale === "hi") return hi_ccsl_export_description(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_description(inputs)
	return en_ccsl_export_description(inputs)
});